import React from 'react';

function UserDetailsForm({ customerDetails, setCustomerDetails, error }) {
    const [phoneError, setPhoneError] = React.useState('');
    const [emailError, setEmailError] = React.useState('');
    const [nameError, setNameError] = React.useState('');
    const [addressError, setAddressError] = React.useState('');
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomerDetails((prev) => ({ ...prev, [name]: value }));
        if (name === 'name') {
            const trimmed = value.trim();
            if (trimmed === '') {
                setNameError('Name is required');
            } else if (trimmed.length < 2) {
                setNameError('Name must be at least 2 characters');
            } else {
                setNameError('');
            }
        }
        if (name === 'phone') {
            const trimmed = value.trim();
            if (trimmed === '') {
                setPhoneError('Phone number is required');
            } else if (!/^[6-9]\d{9}$/.test(trimmed)) {
                setPhoneError('Please enter a valid 10-digit Indian phone number');
            } else {
                setPhoneError('');
            }
        }
        if (name === 'email') {
            const trimmed = value.trim();
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (trimmed === '') {
                setEmailError('');
            } else if (!emailPattern.test(trimmed)) {
                setEmailError('Please enter a valid email address');
            } else if (/\s/.test(trimmed)) {
                setEmailError('Email cannot contain spaces');
            } else if (/\.\./.test(trimmed)) {
                setEmailError('Email cannot contain consecutive dots');
            } else if (/^\.|\.$/.test(trimmed)) {
                setEmailError('Email cannot start or end with a dot');
            } else if (!/^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(trimmed)) {
                setEmailError('Email domain is invalid');
            } else {
                setEmailError('');
            }
        }
        if (name === 'address') {
            const trimmed = value.trim();
            if (trimmed === '') {
                setAddressError('Address is required');
            } else if (trimmed.length < 5) {
                setAddressError('Enter Valid Address');
            } else {
                setAddressError('');
            }
        }
    };
    return (
        <>
            <div className='form-group'>
                <label>Name <span className='required'>*</span></label>
                <div className='form-input-wrapper'>
                    <input
                        type='text'
                        name='name'
                        value={customerDetails.name}
                        onChange={handleChange}
                        placeholder='Enter your name'
                        className='form-input'
                    />
                    {nameError && (
                        <div className='error-message'>{nameError}</div>
                    )}
                </div>
            </div>
            <div className='form-group'>
                <label>Phone<span className='required'>*</span></label>
                <div className='form-input-wrapper'>
                    <input
                        type='tel'
                        name='phone'
                        inputMode='numeric'
                        value={customerDetails.phone}
                        onChange={handleChange}
                        placeholder='Enter your phone number'
                        className='form-input'
                    />
                    {phoneError && (
                        <div className='error-message'>{phoneError}</div>
                    )}
                </div>
            </div>
            <div className='form-group'>
                <label>Email</label>
                <div className='form-input-wrapper'>
                    <input
                        type='email'
                        name='email'
                        value={customerDetails.email}
                        onChange={handleChange}
                        placeholder='Enter your email'
                        className='form-input'
                    />
                    {emailError && (
                        <div className='error-message'>{emailError}</div>
                    )}
                </div>
            </div>
            <div className='form-group'>
                <label>Address<span className='required'>*</span></label>
                <div className='form-input-wrapper'>
                    <textarea
                        name='address'
                        value={customerDetails.address}
                        onChange={handleChange}

                        placeholder='Enter your delivery address'
                        className='form-input'
                        rows='3'
                    />
                </div>
            </div>
            {addressError && (
                <div className='error-message'>{addressError}</div>
            )}
            {error && <div className="error-message pd-10">{error}</div>}
        </>
    );
}


export default UserDetailsForm;
